import watchGetPopularContentRequested from './getPopularContentSaga';

export default [
  watchGetPopularContentRequested(),
];
